import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import { events } from '@mailobj-browser/front/js/events/promised/event.js'
import message from '@mailobj-browser/front/js/events/types/message.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import never from '@mailobj-browser/front/js/utils/never.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import load, { release } from '@mailobj-browser/front/js/worker/worker.js'

const { parse, stringify } = JSON

const onMessages = events(message, { passive })

export default async function* (
  target,
  url,
  type,
  value,
  { aborted = never, ...options } = {}
) {
  const { worker, uid } = load(url, options)
  const promises = Promise.any([aborted, removed(target)])
  const messages = onMessages(worker, promises)

  worker.postMessage(stringify({ type, uid, value }))

  try {
    for await (const { data } of messages) {
      const response = parse(data)

      if (uid === response.uid) {
        yield response
      }
    }
  } finally {
    await messages.return()
  }
}
